// extracted by css-extract-rspack-plugin
export default {"radio":"cFR5y6SIIM8qQpHc","radios":"g2KAZF5Zg3w9dJUn","radios-nested":"Ewj4jB4KrOEOCahM","radios-horizontal":"bUHfRA4aKy0srXZv","radios-section":"Yo4VtGAK8lwbm7m7"};